/**
 * Shared types, constants, and initial state for the Profile settings page.
 */

/** Firestore healthcare-facility document shape used on the profile page. */
export interface HealthFacility {
  id: string;
  name?: string;
  Name?: string;
  is_external_organization?: boolean;
}

/** Internal organization linked to an external healthcare facility. */
export interface InternalOrganization {
  facility_id: string;
  facility_name: string;
}

/** Editable profile fields managed by the profile form. */
export interface ProfileDetails {
  firstName: string;
  lastName: string;
  email: string;
  profilePicture: string;
}

/** Source identifier stamped on every message posted by the RISA browser extension. */
export const RISA_EXTENSION_SOURCE = "RISA_EXTENSION";

/**
 * Authenticated session payload broadcast by the extension on a `LOGGED_IN` event.
 */
export interface ExtensionLoginPayload {
  accessToken: string;
  tokenType: string;
  expiresIn: number;
  user: {
    id: string;
    email: string;
    firstName: string;
    lastName: string;
  };
  facilityId: string;
  roleId: string;
}

/**
 * Auth-state snapshot the extension reports in response to `GET_AUTH_STATE`.
 */
export interface ExtensionAuthStatePayload {
  deviceId: string | null;
  loggedIn: boolean;
}

/**
 * Shape of the `window.postMessage` payloads emitted by the RISA browser extension.
 */
export interface ExtensionMessage {
  source: typeof RISA_EXTENSION_SOURCE;
  type: "LOGGED_IN" | "LOGGED_OUT" | "AUTH_STATE";
  payload?: ExtensionLoginPayload | ExtensionAuthStatePayload;
}

/** Default empty state for the profile details form. */
export const profileDetailsInitialState: ProfileDetails = {
  firstName: "",
  lastName: "",
  email: "",
  profilePicture: "",
};

/** Select option shape for the health-facility dropdown. */
export interface HealthFacilityOption {
  id: string;
  text: string;
}
